import React,{useRef} from "react";
import { Form, Button } from 'semantic-ui-react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useParams } from "react-router-dom";
import { HTTPURL, REQUEST_OPTIONS } from "../constants/matcher";
import { useForm } from "react-hook-form";

export default function ResetPassword() 
{
    const { token } = useParams();

    const {
        register,
        handleSubmit,
        formState: { errors },
        setValue,
        watch
    } = useForm({ defaultValues: { password: "" } });

    const password = useRef({});
    password.current = watch("password", "");

    const onSubmit = (data) =>
    {
        componentDidMount(data);
    }

    const componentDidMount = (requestData) =>
    {
        REQUEST_OPTIONS.method = 'POST';
        REQUEST_OPTIONS.body = JSON.stringify(requestData);

      fetch(HTTPURL+'user/reset-password', REQUEST_OPTIONS)
        .then(async response => {
            const isJson = response.headers.get('content-type')?.includes('application/json');
            const data = isJson && await response.json();
            if (!response.ok) {
                const error = (data && data.message) || response.status;
                return Promise.reject(error);
            }
            if(data.status === true)
            {
                setValue('password', '');
                setValue('confirmPassword', ''); 
                toast.success(data.message)
            }else{
               toast.error(data.message)
            }
        })
        .catch(error => {
            console.error('There was an error!', error);
        });
    }
    
    return (
      <section className="h-100 bg-dark">
          <div className="container py-5 h-100">
              <div className="row d-flex justify-content-center align-items-center h-100">
                  <div className="col">
                      <div className="card card-registration my-4">
                          <div className="row g-0">
                              <div className="col-xl-6 d-none d-xl-block">
                                  <img src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-registration/img4.webp"
                                      alt="" className="img-fluid"
                                  />
                              </div>

                              <div className="col-xl-6">
                                  <Form onSubmit={handleSubmit(onSubmit)}>
                                      <div className="card-body p-md-5 text-black">
                                          <h3 className="mb-5 text-uppercase">Reset Password</h3>
                                          <div className="form-outline mb-4">
                                              <Form.Field>
                                                  <label className="form-label" htmlFor="Email Address">New Password:</label>
                                                  <input
                                                      placeholder='Enter your new password!'
                                                      type="password"
                                                      {...register("password", {
                                                        required: true,
                                                        pattern: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,15}$/
                                                       })}
                                                      className="form-control form-control-lg"
                                                  />
                                              </Form.Field>
                                            {errors.password && errors.password.type === "required" && <span className="validation-error">This is required</span>}
                                            {errors.password && errors.password.type === "pattern" && <span className="validation-error">At least 6 chars long,digit,upper case,lower case</span>}
                                            
                                            <Form.Field>
                                            <input
                                                
                                                    type="hidden"
                                                    {...register("token")}
                                                    value={token}
                                                  />
                                            </Form.Field>
                                          </div>
                                          <div className="form-outline mb-4">
                                            <div className="form-outline">
                                                <div className="form-outline">
                                                    <Form.Field>
                                                        <label className="form-label" htmlFor="Confirm Password">Confirm Password</label>
                                                        <input
                                                        placeholder='Confirm Password'
                                                        type="password"
                                                        {...register("confirmPassword", {
                                                        required: true,
                                                        validate: value =>
                                                            value === password.current || "The passwords do not match"
                                                        })}
                                                        className="form-control form-control-lg"
                                                        />
                                                    </Form.Field>
                                                    {errors.confirmPassword && errors.confirmPassword.type === "required" && <span className="validation-error">This is required</span>}
                                                    {errors.confirmPassword && <p className="validation-error">{errors.confirmPassword.message}</p>}
                                                </div>
                                            </div>
                                        </div>
                                          <div className="d-flex justify-content-end pt-3">
                                          <Button type='submit' className="btn btn-warning btn-lg ms-2">Change Password</Button>
                                          </div>
                                      </div>
                                  </Form>
                                </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
      </section>
  )
}